import { adminApi } from './clients';

/**
 * The re-enrolments a staff member may see, and the counts above them.
 *
 * Both are scoped by the server to the campuses that person holds — asking for a campus they do
 * not hold is refused rather than quietly answered, so these can be called with whatever the
 * screen's filter says without the screen having to police it.
 */

export const fetchApprovals = async ({
    scope = 'waiting', status = '', stage = '', college = '', ...filters
} = {}) => {
    // Only the filters that are set. An empty one sent as "" would be a filter the server has to
    // decide to ignore, and the query string would say something that is not being asked.
    const applied = Object.fromEntries(
        Object.entries(filters).filter(([, value]) => String(value ?? '').trim() !== '')
    );

    const { data } = await adminApi.get('/fetchParentAddDetails', {
        params: {
            scope,
            ...(status ? { status } : {}),
            ...(stage ? { stage } : {}),
            ...(college ? { college } : {}),
            ...applied,
        },
    });
    return data?.ParentAddress || [];
};

/** The counts above the list. Given the same campus the list was asked for, so the two agree. */
export const fetchApprovalStats = async ({ college = '' } = {}) => {
    const { data } = await adminApi.get('/approvalStats', {
        params: college ? { college } : {},
    });
    return data || {};
};

/**
 * The children re-enrolled, a row each: the Enrolled students tab. The same children the roll by
 * child counts as Enrolled on Not re-enrolled, and the same campus scoping as the list.
 */
export const fetchEnrolledStudents = async ({ college = '' } = {}) => {
    const { data } = await adminApi.get('/enrolled-students', {
        params: college ? { college } : {},
    });
    return data?.students || [];
};
